<!-- 报告导出管理 -->
<template>
  <div class="page">
    <div
      class="paginations"
      :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }"
    >
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="报告名称：">
            <el-input
              size="small"
              v-model="searchData.reportName"
              placeholder="请输入报告名称"
            />
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>
        </el-form>
        <div class="addition">
          <el-button @click="add">
            添加
            <i class="h_icon icon-add"></i>
          </el-button>
        </div>
      </div>

      <div class="table_box">
        <el-table :data="tableObj.list">
          <el-table-column width="200" prop="reportName" label="报告名称" />
          <el-table-column width="250" prop="zykName" label="当前资源库" />
          <el-table-column prop="url" label="url" />
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <i
                class="icona icon-edit"
                title="编辑"
                @click="edit(scope.row)"
              />
              <i
                class="icona icon-delete"
                title="删除"
                @click="cutOut([scope.row.id])"
              />
              <i
                class="icona el-icon-upload"
                title="导出"
                @click="exportData(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <pageNumber
          :paginations="7"
          :pageNum="searchData.pageDto.pageNum"
          :isPageSizes="true"
          :page-size="searchData.pageDto.pageSize"
          :total="tableObj.total"
          :jumpTo="tableObj.jumpTo"
          @currentChange="search"
        ></pageNumber>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      :title="uploadBox.title"
      :visible.sync="uploadBox.show"
      :close-on-click-modal="false"
      class="pop_up"
      append-to-body
      :before-close="handleClose"
      @opened="opened"
    >
      <el-form
        ref="uploadBox"
        :model="uploadBox.data"
        :rules="uploadBox.rules"
        label-width="88px"
      >
        <el-form-item label="报告名称：">
          <el-input
            size="small"
            v-model="uploadBox.data.reportName"
            placeholder="请输入报告名称"
          />
        </el-form-item>
        <el-form-item label="级别：">
          <el-radio-group
            v-model="uploadBox.data.projectType"
            @input="radioChange"
          >
            <el-radio :label="1">国家级</el-radio>
            <el-radio :label="2">省级</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="资源库：">
          <el-select
            size="small"
            placeholder="请选择资源库"
            v-model="uploadBox.data.zykid"
            clearable
            @change="selectChange"
          >
            <el-option
              v-for="(item, i) in zykDataList"
              :key="i"
              :label="item.zykName"
              :value="item.zykId"
            />
          </el-select>
          <el-input
            style="display: none"
            size="small"
            v-model="uploadBox.data.zykName"
          />
        </el-form-item>
        <el-form-item label="url：">
          <el-input
            size="small"
            type="textarea"
            v-model="uploadBox.data.url"
            placeholder="请输入url"
          />
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="sureClick">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页
export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      // 查询条件
      searchData: {
        reportName: "", //报告名称
        pageDto: {
          pageNum: 1,
          pageSize: 10,
        },
      },
      // 表格数据
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      // 新增弹窗
      uploadBox: {
        show: false,
        title: "",
        data: {
          id: null,
          reportName: "", //报告名称
          zykid: "", //资源库
          zykName: "",
          url: "", //url
          projectType: 1, //级别
        },
        rules: {},
      },
      zykDataList: [],
      loading: "", //是否导出加载中
    };
  },
  mounted() {
    this.$store.commit("modifyVague", false);
    this.search();
  },
  methods: {
    // 切换 国家级/省级 单选按钮
    radioChange(value) {
      this.uploadBox.data.zykid = "";
      this.source(value);
    },
    // 获取资源库
    source(value) {
      this.$axios
        .post(this.$apiurls.major_getAllZykList, value, { loading: false })
        .then((res) => {
          if (res.data) {
            this.zykDataList = res.data;
          }
        });
    },
    // 选择资源库
    selectChange(val) {
      let name = "";
      if (val) {
        let obj = this.zykDataList.find((item) => item.zykId == val);
        if (obj) name = obj.zykName;
      }
      this.uploadBox.data.zykName = name;
    },
    // 查询表格
    search(obj = {}) {
      this.tableObj.jumpTo = obj.page ? obj.page : 1;
      this.searchData.pageDto.pageNum = obj.page ? obj.page : 1;
      this.searchData.pageDto.pageSize = obj.limit ? obj.limit : 10;
      this.$axios
        .post(this.$apiurls.getLv2ReportExportInfo, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.list;
            this.tableObj.list = data;
            this.tableObj.total = res.data.total;
          }
        })
        .catch(() => {
          this.$store.commit("modifyVague", false);
        });
    },
    // 重置表格
    reset() {
      this.searchData.reportName = "";
      this.search();
    },
    // 点击新增
    add() {
      // 每次新增打开弹框前都先清除之前的表单数据
      for (const key in this.uploadBox.data) {
        if (key === "id") this.uploadBox.data[key] = null;
        else this.uploadBox.data[key] = "";
      }
      this.uploadBox.title = "添加报告";
      this.uploadBox.show = true;
      this.uploadBox.data.projectType = 1;
      this.source(1);
      this.$store.commit("modifyVague", true);
    },
    // 点击编辑按钮
    edit(row) {
      this.uploadBox.title = "修改报告";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      this.source(row.projectType || 1);
      for (const key in row) {
        this.uploadBox.data[key] = row[key];
      }
    },
    // 添加/修改请求接口
    sureClick() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          this.$axios
            .post(this.$apiurls.addLv2ReportExportInfo, this.uploadBox.data, {
              loading: false,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: this.uploadBox.data.id ? "编辑成功！" : "添加成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
            })
            .catch(() => {
              this.$store.commit("modifyVague", false);
            });
        }
      });
    },
    // 点击删除按钮
    cutOut(id) {
      this.$store.commit("modifyVague", true);
      this.$confirm("此操作将永久删除该报告, 是否继续?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$axios
          .post(this.$apiurls.delLv2ReportExportInfo, id, {
            loading: false,
          })
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功！",
                type: "success",
              });
              this.search();
            }
            this.$store.commit("modifyVague", false);
          })
          .catch(() => {
            this.$store.commit("modifyVague", false);
          });
      });
    },
    // 点击导出
    exportData(item) {
      this.loading = this.$loading({
        lock: true,
        text: "正在导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .get(
          `${this.$apiurls.exportLv2ReportExportInfo}?name=${
            item.reportName
          }&zykId=${item.zykid}&zykName=${
            item.zykName
          }&token=${sessionStorage.getItem("lrmv2token")}&url=${item.url}`,
          {
            loading: false,
            responseType: "blob",
          }
        )
        .then((res) => {
          if (res) {
            let url = window.URL.createObjectURL(res);
            let link = document.createElement("a"); //a标签下载
            link.href = url;
            link.download = `${item.reportName}.pdf`;
            link.click();
            setTimeout(() => {
              if (document.body.contains(link)) document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 0);
          }
          this.loading.close();
        });
    },
    // 打开弹框
    opened() {
      this.$refs.uploadBox.clearValidate();
    },
    // 关闭弹框
    handleClose() {
      this.uploadBox.show = false;
      this.$store.commit("modifyVague", false);
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped>
</style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped>
</style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}
// 搜索
.table-search-box-hander {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-form {
  height: 100%;
}
.table_box {
  margin-bottom: 0;
}
</style>
<style lang="scss">
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;

  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;

    .el-select-dropdown__item {
      color: #fff !important;
    }

    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }

    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }

    .selected {
      color: rgba(27, 246, 248);
    }
  }

  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}

.el-input__inner {
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}
.el-textarea__inner {
  font-family: initial;
}
.el-icon-upload {
  font-size: 18px !important;
  color: #1bf6f8 !important;
  margin-right: 5px;
  cursor: pointer;
}
</style>
